/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeat any text as many times as you need — joined by a new line, space, comma, or your own separator, with optional numbering.`)
};

const es_tr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repite cualquier texto tantas veces como necesites — unido por un salto de línea, espacio, coma, o tu propio separador, con numeración opcional.`)
};

const de_tr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholen Sie beliebigen Text so oft wie nötig — verbunden durch neue Zeile, Leerzeichen, Komma oder ein eigenes Trennzeichen, mit optionaler Nummerierung.`)
};

const nl_tr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herhaal elk tekst zoveel keer als je wilt - samengevoegd door een nieuwe regel, spatie, komma of je eigen scheidingsteken, met optioneel nummerering.`)
};

const fr_tr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétez n'importe quel texte autant de fois que nécessaire — séparé par une nouvelle ligne, un espace, une virgule ou votre propre séparateur, avec numérotation optionnelle.`)
};

const it_tr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripeti qualsiasi testo tutte le volte che necessiti — unito da una nuova riga, uno spazio, una virgola o dal tuo separatore personalizzato, con numerazione opzionale.`)
};

const pt_br2_tr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repita qualquer texto quantas vezes precisar — unido por uma nova linha, espaço, vírgula ou seu próprio separador, com numeração opcional.`)
};

const pt_tr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repita qualquer texto quantas vezes precisar — unido por uma nova linha, espaço, vírgula ou o seu próprio separador, com numeração opcional.`)
};

const ja_tr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意のテキストを必要な回数だけ繰り返します。改行、スペース、カンマ、または独自のセパレーターで結合され、番号付けはオプションです。`)
};

const zh_tr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将任意文本重复所需的次数——用换行、空格、逗号或你自己的分隔符连接，并可选择编号。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_intro", locale)
	if (locale === "en") return en_tr_intro(inputs)
	if (locale === "es") return es_tr_intro(inputs)
	if (locale === "de") return de_tr_intro(inputs)
	if (locale === "nl") return nl_tr_intro(inputs)
	if (locale === "fr") return fr_tr_intro(inputs)
	if (locale === "it") return it_tr_intro(inputs)
	if (locale === "pt-BR") return pt_br2_tr_intro(inputs)
	if (locale === "pt") return pt_tr_intro(inputs)
	if (locale === "ja") return ja_tr_intro(inputs)
	return zh_tr_intro(inputs)
};